/**
 * @generated SignedSource<<91418aada8fc77fd6095920d96cb6587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "closeNominatedTrade",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "closedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "closedBy",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "givenName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "familyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CloseNominatedTradeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CloseNominatedTradeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d850e87aa31ada644756caea53bbe34f",
    "id": null,
    "metadata": {},
    "name": "CloseNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation CloseNominatedTradeMutation(\n  $id: ID!\n) {\n  closeNominatedTrade(id: $id) {\n    id\n    closedAt\n    closedBy {\n      id\n      email\n      givenName\n      familyName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "72632c52284239741c8684c1cde4bc3f";

module.exports = node;
